import { useEffect, useRef } from 'react';
import { setAppElement, ThemeGlobals } from '@web-stories-wp/design-system';
import { LoadingIndicator } from '@src/components/loading';
import { useFeatures, useStoryEditor } from '@hooks';
import { useAuthorizationManager } from '@hooks/authorization';
import { useStudioContext } from '@hooks/studioContext';
import { isAnimatedThumbnailAssetType } from '@hooks/studioContext/CMSParams';
import AnimatedThumbnailEditor from '@components/animatedThumbnailEditor';

import './Studio.css';

const StoryEditorStudio = () => {
  const { isLoading, storyEditor } = useStoryEditor();

  return isLoading ? <LoadingIndicator /> : storyEditor;
};

const AnimatedThumbnailStudio = () => {
  const { features, isLoading } = useFeatures();
  const { authContext } = useAuthorizationManager();
  const studioContext = useStudioContext();
  const hasRedirected = useRef(false);
  const isEnabled = features?.useAnimatedThumbnailAuthoring?.value === true;

  useEffect(() => {
    if (isLoading || isEnabled || hasRedirected.current || !authContext) {
      return;
    }

    hasRedirected.current = true;
    authContext.redirectToCmsEditForm(studioContext);
  }, [authContext, isEnabled, isLoading, studioContext]);

  return isEnabled ? <AnimatedThumbnailEditor /> : <LoadingIndicator />;
};

const StudioContent = () => {
  const { assetType } = useStudioContext();

  return isAnimatedThumbnailAssetType(assetType) ? (
    <AnimatedThumbnailStudio />
  ) : (
    <StoryEditorStudio />
  );
};

export const Studio = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    setAppElement(containerRef.current);
  }, []);

  return (
    <div
      ref={containerRef}
      id="web-stories-editor"
      className="studio-container web-stories-editor-app-container"
    >
      <ThemeGlobals.Styles />
      <StudioContent />
    </div>
  );
};
